import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Typography, alpha, makeStyles } from '@material-ui/core';
import { ReactComponent as DetractorIcon } from '../../../../assets/icons/sentiment_dissatisfied.svg';
import { ReactComponent as NeutralIcon } from '../../../../assets/icons/sentiment_neutral.svg';
import { ReactComponent as PromoterIcon } from '../../../../assets/icons/sentiment_satisfied.svg';

const useStyles = makeStyles(({ palette: { primary }, spacing }) => ({
  root: {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, minmax(0,1fr))',
    gridGap: 24,
    height: 124,
    marginTop: spacing(6),
  },
  scoreWrapper: {
    borderRadius: 8,
    backgroundColor: primary.white,
    padding: spacing(3, 6, 3, 6),
    boxShadow: `0px 2px 8px 0px ${alpha(primary.black, 0.17)}`,
    display: 'flex',
    justifyContent: 'space-between',
  },
  textWrapper: {
    display: 'grid',
    textAlign: 'start',
  },
  labelWrapper: {
    display: 'flex',
    alignItems: 'center',
  },
  label: {
    fontFamily: 'ProximaNova-Regular',
    color: primary.bluish1,
  },
  promotersLabel: {
    color: primary.green1,
    marginRight: spacing(2),
  },
  neutralLabel: {
    color: primary.bluish6,
    marginRight: spacing(2),
  },
  detractorsLabel: {
    color: primary.red1,
    marginRight: spacing(2),
  },
  icon: {
    width: 32,
    height: 32,
    marginBottom: spacing(2),
  },
  iconDetractor: {
    '& path': {
      fill: primary.red1,
    },
  },
  iconNeutral: {
    '& path': {
      fill: primary.bluish6,
    },
  },
  iconPromoter: {
    '& path': {
      fill: primary.green1,
    },
  },
}));

const ReportResultsGrid = ({ translations, results = {} }) => {
  const classes = useStyles();

  const { promoters, neutrals, detractors } = results;

  return (
    <div className={classes.root}>
      <div className={classes.scoreWrapper}>
        <div className={classes.textWrapper}>
          <DetractorIcon
            className={classNames(classes.icon, classes.iconDetractor)}
          />
          <Typography variant="h5" className={classes.label}>
            {translations.detractorsLabel}
          </Typography>
          <div className={classes.labelWrapper}>
            <Typography variant="h2" className={classes.detractorsLabel}>
              {`${detractors?.percentage || 0}%`}
            </Typography>
            <Typography variant="body2" className={classes.label}>
              {`(${detractors?.count || 0})`}
            </Typography>
          </div>
        </div>
        <Typography variant="h5" className={classes.label}>
          {translations.detractorsScore}
        </Typography>
      </div>
      <div className={classes.scoreWrapper}>
        <div className={classes.textWrapper}>
          <NeutralIcon
            className={classNames(classes.icon, classes.iconNeutral)}
          />
          <Typography variant="h5" className={classes.label}>
            {translations.neutralLabel}
          </Typography>
          <div className={classes.labelWrapper}>
            <Typography variant="h2" className={classes.neutralLabel}>
              {`${neutrals?.percentage || 0}%`}
            </Typography>
            <Typography variant="body2" className={classes.label}>
              {`(${neutrals?.count || 0})`}
            </Typography>
          </div>
        </div>
        <Typography variant="h5" className={classes.label}>
          {translations.neutralScore}
        </Typography>
      </div>
      <div className={classes.scoreWrapper}>
        <div className={classes.textWrapper}>
          <PromoterIcon
            className={classNames(classes.icon, classes.iconPromoter)}
          />
          <Typography variant="h5" className={classes.label}>
            {translations.promotersLabel}
          </Typography>
          <div className={classes.labelWrapper}>
            <Typography variant="h2" className={classes.promotersLabel}>
              {`${promoters?.percentage || 0}%`}
            </Typography>
            <Typography variant="body2" className={classes.label}>
              {`(${promoters?.count || 0})`}
            </Typography>
          </div>
        </div>
        <Typography variant="h5" className={classes.label}>
          {translations.promotersScore}
        </Typography>
      </div>
    </div>
  );
};

ReportResultsGrid.propTypes = {
  translations: PropTypes.object.isRequired,
  results: PropTypes.object,
};

export default ReportResultsGrid;
